import React from "react";
import { LANDING } from "../../constants/testIds";
import CommunityButton from "./CommunityButton";

// Sezione secondaria, subito dopo la candidatura: chi non è pronta a candidarsi
// non se ne va a mani vuote, entra nella community e resta in ascolto.
// Volutamente più sobria della CTA principale, per non rubarle attenzione.
export default function CommunityCTA() {
  return (
    <section
      id="community"
      className="py-20 md:py-24 bg-beige font-sans"
      data-testid={LANDING.communitySection}
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="border border-chocolate/15 bg-cream p-8 md:p-12 text-center space-y-6">

          <div className="space-y-3">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
              NON SEI ANCORA PRONTA A CANDIDARTI?
            </span>
            <h2 className="text-2xl sm:text-3xl font-normal font-editorial text-chocolate">
              Entra nella community
            </h2>
            <p className="text-xs sm:text-sm text-chocolate/70 max-w-lg mx-auto font-light leading-relaxed">
              {"Un canale privato su Instagram dove Giulia condivide riflessioni, esercizi e storie vere di donne che sono tornate al centro della propria vita. Si legge quando vuoi, si esce quando vuoi."}
            </p>
          </div>

          <CommunityButton
            className="bg-bordeaux text-white hover:bg-bordeaux-hover text-sm font-semibold tracking-widest px-8 py-5 rounded-none transition-luxury inline-block"
            testId={LANDING.ctaJoinCommunity}
          >
            UNISCITI ALLA COMMUNITY
          </CommunityButton>

          <p className="text-[11px] text-chocolate/50 font-light">
            {"Gratuito. Scrive solo Giulia: niente caos da chat di gruppo, nessun obbligo di rispondere."}
          </p>

        </div>
      </div>
    </section>
  );
}
